import { UiEvent } from '../utils/ui-event';

export class GlobalClickTrackingEditorial {
	constructor() {
		let links: NodeListOf<HTMLAnchorElement>;

		// Sticky header
		links = document.querySelectorAll(
			'.header-sticky a, .fixed-navigation a, .sticky-navigation a, #sticky-header a'
		);
		links.forEach((link) => {
			link.addEventListener(
				'click',
				(event: Event) => {
					if (link.hash.length > 0) {
						UiEvent.trackUIEvent(
							'header-sticky',
							'anchor-hash-link',
							event.type,
							link.hash
						);
					} else {
						UiEvent.trackUIEvent(
							'header-sticky',
							'anchor-link',
							event.type,
							new URL(link.href).pathname
						);
					}
				},
				{ once: true }
			);
		});

		// Default header
		links = document.querySelectorAll(
			'header.header a, .header-transparent a, .navigation-mobile__wrapper a, .navigation a, #masthead a, #transparent-header a'
		);
		links.forEach((link) => {
			link.addEventListener(
				'click',
				(event: Event) => {
					if (link.hash.length > 0) {
						UiEvent.trackUIEvent(
							'header-default',
							'anchor-hash-link',
							event.type,
							link.hash
						);
					} else {
						UiEvent.trackUIEvent(
							'header-default',
							'anchor-link',
							event.type,
							new URL(link.href).pathname
						);
					}
				},
				{ once: true }
			);
		});

		// Footer internal links
		links = document.querySelectorAll('.internal-links a');
		links.forEach((link) => {
			link.addEventListener(
				'click',
				(event: Event) => {
					UiEvent.trackUIEvent(
						'footer',
						'anchor-link',
						event.type,
						new URL(link.href).pathname
					);
				},
				{ once: true }
			);
		});

		// Footer external links
		links = document.querySelectorAll('.external-links a');
		links.forEach((link) => {
			link.addEventListener(
				'click',
				(event: Event) => {
					UiEvent.trackUIEvent(
						'footer',
						'anchor-link',
						event.type,
						new URL(link.href).hostname
					);
				},
				{ once: true }
			);
		});

		document.querySelector('[data-bi-id="mobile-navigation-toggle"]')?.addEventListener(
			'click',
			(event) => {
				UiEvent.trackUIEvent('mobile-navigation', 'mobile-navigation-toggle', event.type);
			},
			{ once: true }
		);
	}
}
